// extracted by mini-css-extract-plugin
export var active = "_dw-7";
export var container = "_dw-0";
export var evenWidth = "_dw-4";
export var large = "_dw-5";
export var outlet = "_dw-8";
export var slide = "_dw-2";
export var small = "_dw-6";
export var tab = "_dw-3";
export var tabs = "_dw-1";